export default __webpack_public_path__ + "static/1253-2d46f53db0902890e718b614bbf2d9c6.gif";